(function () {
    'use strict';
    var controllerId = 'stakRifiutoPopup';
    angular.module('app').controller(controllerId, ['$scope', '$filter', 'datacontext', '$uibModalInstance', 'test', 'readOnly', '$translate', stakRifiutoPopup]);

    function stakRifiutoPopup($scope, $filter, datacontext, $uibModalInstance, test, readOnly, $translate) {
        $scope.readOnly = readOnly;
        $scope.record = test;
        
        $scope.print = function () {
            function getImage(url, callback) {
               
                var image = new Image();

                image.onload = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth; 
                    canvas.height = this.naturalHeight; 

                    canvas.getContext('2d').drawImage(this, 0, 0);                    
                    callback(canvas.toDataURL('image/png'));
                };

                image.src = url;
            }

            var note = $scope.record.note && $scope.record.note != null ? $scope.record.note : $translate.instant('NonIndicato');
            // Usage
            getImage('/Content/images/logoss.png', function (image) {                
                var text = "<p>"+ $translate.instant('Commerciale') + ' ' + $scope.record.OpUpdate + " "+ $translate.instant('HaRifiutatoIlTest') + ': ' + $scope.record.title + ".</p>";                
                text += "<p>" + $translate.instant('MotivoRifiuto') +': '+ "</p><p>" + note + "</p>";

                var doc = new jsPDF();
                var date = $filter('date')(new Date(), 'dd/MM/yyyy');
                doc.fromHTML(date, 174, 22);
                doc.fromHTML(text, 15, 35,
                    {
                        'width': 180
                    });
                doc.addImage(image, 'png', 10, 15);
                doc.save($translate.instant('DocRifiuto')+".pdf");                                  
            });
        };

        $scope.ok = function (isValid) {
            if (isValid) {                
                $uibModalInstance.close($scope.record);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };          
    }
})();